import React, { useRef } from 'react';
import './Button.css';
import { trackEvent } from '../firebase';

const Button = ({
  children,
  type = 'primary',
  size = 'medium',
  onClick,
  disabled = false,
  icon,
  emoji,
  className = '',
  analyticsId,
  analyticsEvent = 'ui_button_click',
  analyticsProps = {},
  analyticsDisabled = false,
  ...props
}) => {
  const lastClickRef = useRef(0);

  const buttonClasses = [
    'button',
    `button-${type}`,
    `button-${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const resolveButtonId = () => {
    if (analyticsId) return analyticsId;
    if (props.id) return props.id;
    if (props['data-analytics-id']) return props['data-analytics-id'];
    if (props['aria-label']) return props['aria-label'];
    const text = typeof children === 'string' ? children : '';
    return (text || 'button').trim().slice(0, 50);
  };

  const handleClick = (e) => {
    if (!disabled && !analyticsDisabled) {
      const now = Date.now();
      if (now - lastClickRef.current > 300) {
        lastClickRef.current = now;
        const button_id = resolveButtonId();
        trackEvent(analyticsEvent, {
          button_id,
          variant: type,
          size,
          path: window.location.pathname,
          ...analyticsProps,
        });
      }
    }
    onClick?.(e);
  };

  return (
    <button
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {emoji && <span className='button-emoji'>{emoji}</span>}
      {icon && <span className='button-icon'>{icon}</span>}
      {children && <span className='button-text'>{children}</span>}
    </button>
  );
};

export default Button;
